import { type Profile, ProfileSchema } from '../../../types'
import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type GetProfileResponsePayload = {
  profile: Profile
}

export const GetProfileResponsePayloadSchema: CborSchema<GetProfileResponsePayload> =
  defineCborSchema<GetProfileResponsePayload>({
    profile: CborField({ key: 0, type: ProfileSchema }),
  })
